import resetInit from "../js/resetPassword/main";

document.addEventListener("DOMContentLoaded", resetInit);